import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { OutletContext } from '../../layout/Layout';
import PageTitleSubheader from '../../layout/subheader/PageTitleSubheader';
import { Card, CardBody } from '@patternfly/react-core';
import { FolderTypesEnum } from '../../enums/folder-types-enum';
import { useMount } from 'react-use';
import AddNewDropdown from '../../components/ui/addNewDropdownButton/AddNewDropdown';
import { PresentSidebarContext } from '../../helpers/sidebar-contexts/present-sidebar-context';
import {
	SubNavContext,
	TipAndTrickPageTypeEnum,
} from '../../helpers/sub-nav-contexts/sub-nav-context';

export enum ListType {
	All,
	Recents,
	Favorites,
}

type Props = {
	listType?: ListType;
};

const Present = (props: Props) => {
	const navigate = useNavigate();
	const { folderId } = useParams();
	const { setSubSide, subNavExpanded, setSubNavExpanded } = useOutletContext<OutletContext>();
	const [subNavContext, setSubNavContext] = useState<SubNavContext>();
	const pathname = useLocation().pathname;

	useMount(() => {
		const prevPresentPage = localStorage.getItem('prevPresentPage');
		if (prevPresentPage) {
			navigate(`/present/${prevPresentPage}`);
		}

		setSubNavContext({
			...subNavContext,
			TipAndTrickPageType: TipAndTrickPageTypeEnum.PRESENT,
		});
	});

	useEffect(() => {
		const headerContext = {
			header: '',
			subheader: '',
		};

		setSubSide({
			subheaderContext: (
				<PageTitleSubheader
					pageTitle="Present"
					expanded={subNavExpanded}
					setExpanded={setSubNavExpanded}
					isCollapsable
					subNavContext={subNavContext}
				/>
			),
			sidebarContext: PresentSidebarContext,
			sidebarHeaderContext: headerContext,
			folderHeadingTitle: 'Presentations',
			folderType: FolderTypesEnum.Presentation,
		});
	}, [setSubSide, subNavExpanded, setSubNavExpanded, subNavContext]);

	return (
		<Card>
			<CardBody>
				{!pathname.includes('/recents') && !pathname.includes('/favorites') && (
					<AddNewDropdown
						folderHeadingTitle="Presentation"
						folderType={FolderTypesEnum.Presentation}
						onSetSubSide={setSubSide}
					/>
				)}

				<Outlet />
			</CardBody>
		</Card>
	);
};

export default Present;
